import React, { useEffect, useRef } from "react";

const SurveyMonkeyModule = ({ module }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (ref) {
            const script = document.createElement('script');
            script.src = `${module?.iframe}`;
            ref?.current?.appendChild(script);

        }
    }, [ref, module?.iframe]);

    return (
        <div className='survey-monkey__root'>
            <div className='survey-monkey__container'>
                <span ref={ref} id="smcx-sdk">
                </span>
            </div>
        </div>
    );
};

export default SurveyMonkeyModule;